/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import type {
  FixedSizeCodec,
  FixedSizeDecoder,
  FixedSizeEncoder,
} from "@solana/kit";
import { combineCodec, getEnumDecoder, getEnumEncoder } from "@solana/kit";

export enum LockType {
  Permanent = 0,
}

export type LockTypeArgs = LockType;

export function getLockTypeEncoder(): FixedSizeEncoder<LockTypeArgs> {
  return getEnumEncoder(LockType);
}

export function getLockTypeDecoder(): FixedSizeDecoder<LockType> {
  return getEnumDecoder(LockType);
}

export function getLockTypeCodec(): FixedSizeCodec<LockTypeArgs, LockType> {
  return combineCodec(getLockTypeEncoder(), getLockTypeDecoder());
}
